import { render } from "./QApage.vue?vue&type=template&id=4a57126a&scoped=true"
import script from "./QApage.vue?vue&type=script&lang=js"
export * from "./QApage.vue?vue&type=script&lang=js"

import "./QApage.vue?vue&type=style&index=0&id=4a57126a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a57126a"]])

export default __exports__